import React, { PropsWithChildren } from 'react'
import { Grid, Button, ButtonProps } from '@mui/material'
import { Container, ChildrenContainer, Title } from './TablePageContainer.style'

type TablePageContainerProps = PropsWithChildren<{
  title?: string
  action?: Partial<ButtonProps> & {
    title: string
  }
  containerStyle?: React.CSSProperties
}>

const TablePageContainer = ({
  title,
  children,
  action,
  containerStyle,
}: TablePageContainerProps) => (
  <Container style={containerStyle}>
    <Grid
      container
      spacing={{ xs: 2, md: 1 }}
      direction="column"
      justifyContent="flex-start"
      flexWrap="nowrap"
    >
      <Grid
        item
        container
        justifyContent="space-between"
        alignItems="center"
        gap={1}
      >
        <Title>{title}</Title>
        {action && (
          <Button
            sx={{ height: 'max-content' }}
            onClick={action.onClick}
            fullWidth={false}
            color="primary"
            variant="contained"
            {...action}
          >
            {action.title}
          </Button>
        )}
      </Grid>
      <ChildrenContainer item>{children}</ChildrenContainer>
    </Grid>
  </Container>
)

export default TablePageContainer
